import { type AppActivity, createRefreshClock } from "@lib/logic";

// On web the app counts as active while its browser tab is visible
const browserTabVisibility: AppActivity = {
  isActive: () => document.visibilityState === "visible",

  subscribe: onChange => {
    document.addEventListener("visibilitychange", onChange);

    return () => {
      document.removeEventListener("visibilitychange", onChange);
    };
  },
};

/** Web's refresh clock. It pauses while the browser tab is hidden. */
export const refreshClock = createRefreshClock({ activity: browserTabVisibility });

/** Ticks every minute, for times shown to the minute, such as when a booking made now starts. */
export const minuteClock = createRefreshClock({ activity: browserTabVisibility, bucketMinutes: 1 });
